export const enum SurveyStates {
  LOCKED = "LOCKED",
  UNLOCKED = "UNLOCKED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}
